import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/UserEvaluations';
// FOR ONE GRAPHQL QUERY
export const GET_USER_EVALUATIONS = defineAsyncActionTypes(`${prefix}/GET_USER_EVALUATIONS`);
export const GET_USER_EVENY_EVALUATIONS = defineAsyncActionTypes(
  `${prefix}/GET_USER_EVENY_EVALUATIONS`
);
